import imgSrc from '../javascripts/imgSrc'
let it = {
  postureHome: {
    indexPage: {
      a_posture_title: `Raport Postura`,
      show: `1`
    },
    coverInfo: {
      customerName: `Soggetto della Prova`,
      date: `Data della Prova`,
      time: `Durata della Prova`,
      userName: `Analista della Prova`,
      clickEnterReport: `entra`
    }
  },

  postureIpad: {
    bullet: {
      Home: `Home`,
      Posturedata: 'Dati della postura',
      Score: 'Valutazione del  Rischio',
      Muscle: 'Valutazione Muscolare',
      Solution: 'Soluzione'
    },
    front: 'davanti',
    side: 'lato',
    viwesNav: 'Lato | Davanti',
    InvalidData: 'Report non valido',
    qrcode: 'Mandaci un email e sblocca i tuoi esercizi',
    expertsWalk: 'Senno Posture',
    smallProgram: 'support@sennotech.com',
    clickRightTop: 'Fai click nel pulsante in alto a destra',
    clickTranspond: 'clicca per condividere il mini programma',
    symptoms: {
      head: [
        {
          name: 'Inclinazione testa',
          key: 'headSidesway',
          normal: {
            left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [
            {
              name: 'Sforzo cronico dei muscoli e dei legamenti',
              des: `L'Inclinazione cefalica prolungata o il torcicollo possono portare a uno sforzo cronico del legamento cervicale posteriore e dei muscoli circostanti. `
            },
            {
              name: 'Spondilosi cervicale',
              des: 'Il collo e’ una catena di 7 ossa collegate da legamenti e avvolte da muscoli che sostengono un peso di 7 kg ( la tua testa!) Il dolore al collo e’un problema spesso attribuito al lavoro costante contro la gravita’ per bilanciare la testa sul busto. La posizione anormale dei tessuti molli e delle ossa da una testa ectopica aumenta il rischio di degenerazione dolorosa dei dischi intervertebrali'
            }
          ]
        },
        {
          name: 'Testa in avanti',
          key: 'headLean',
          normal: {
            normal: imgSrc.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [
            {
              name: 'Vertigini e mal di testa',
              des: `L'ipossia cerebrale causata da una cattiva circolazione derivante dalla postura con la testa in avanti puo’  portare a vertigini e mal di testa.`
            },
            {
              name: 'Spondilosi cervicale',
              des: 'Il collo e’ una catena di 7 ossa collegate da legamenti e avvolte da muscoli che sostengono un peso di 7 kg ( la tua testa!) Il dolore al collo e’ un problema spesso attribuito al lavoro costante contro la gravita’ per bilanciare la testa sul busto. La posizione anormale dei tessuti molli e delle ossa da una testa ectopica aumenta il rischio di degenerazione dolorosa dei dischi intervertebrali'
            }
          ]
        }
      ],
      shoulder: [
        {
          name: 'Spalle Irregolari',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [
            {
              name: 'Mal di testa cronico',
              des: 'Spalle irregolari possono portare a mal di testa cronico.'
            },
            {
              name: 'Speroni ossei',
              des: 'Le spalle che non sono a livello generano una forza anormale sul collo, rendendo una persona incline alla degenerazione della colonna cervicale e in alcuni casi a speroni ossei. '
            },
            {
              name: 'Lombalgia',
              des: 'Le spalle inclinate possono causare Inclinazione laterale del bacino, squilibrio muscolare in vita e lombalgia.'
            },
            {
              name: 'Discrepanza della lunghezza delle gambe',
              des: `L'Inclinazione laterale pelvica aumenta anche il rischio di un' apparente disuguaglianza nella lunghezza delle gambe.`
            }
          ]
        },
        {
          name: 'Spalle Curve',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.ROUND_SHOULDER
          },
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [
            {
              name: 'Malattia cardiovascolare',
              des: 'Le spalle curve aumentano la tensione del diaframma aumentando il rischio di malattie cardiovascolari.'
            },
            {
              name: 'Mal di testa',
              des: 'La tensione del collo e delle spalle con le spalle curve puo’ opersino causare compressione del nervo cervicale e mal di testa.'
            },
            {
              name: 'Braccia intorpidite',
              des: 'La compressione del nervo cervicale puo’ anche provocare intorpidimento o parestesia delle braccia.'
            }
          ]
        }
      ],
      trunk: [
        {
          name: 'Scoliosi',
          key: 'spineSidesway',
          normal: {
            left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [
            {
              name: `Scoliosi`,
              des: `Ulteriore ispezione 3D e’ indicata per diagnosticare la scoliosi.`
            },
            {
              name: `Spalle irregolari`,
              des: `La scoliosi puo’ essere accompagnata da spalle irregolari.`
            },
            {
              name: `Fianchi irregolari`,
              des: `La scoliosi puo’ essere accompagnata da fianchi irregolari.`
            }
          ]
        }
      ],
      pelvis: [
        {
          name: 'Fianchi Irregolari',
          key: 'pelvisLean',
          normal: {
            left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [
            {
              name: 'Dolore cronico',
              des: 'Fianchi irregolari possono causare dolore estremo.'
            },
            {
              name: 'Ernia del disco lombare',
              des: 'I fianchi irregolari possono aumentare il rischio di ernia del disco lombare.'
            },
            {
              name: 'Discrepanza della lunghezza delle gambe',
              des: 'I fianchi irregolari possono aumentare il rischio di discrepanza nella lunghezza delle gambe.'
            }
          ]
        }
      ],
      'lower extremity': [
        {
          name: 'Gambe arcuate (curvatura a forma di O)',
          key: 'legO',
          normal: {
            normal: imgSrc.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_O
          },
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [
            {
              name: `Lesione del menisco`,
              des: `La pressione sull'arto inferiore nelle persone con le gambe arcuate viene modificata in modo tale`
            },
            {
              name: 'Artrite',
              des: `Le gambe  gravemente storte possono eventualmente progredire verso l'artrite nello spazio interstiziale laterale dell'articolazione.`
            }
          ]
        },
        {
          name: 'Ginocchio Valgo (Ginocchia ad X)',
          key: 'legX',
          normal: {
            normal: imgSrc.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [
            {
              name: 'Lesione del Menisco',
              des: `Poiche’ le ginocchia ad X alterano la direzione della forza dell'arto inferiore, il ginocchio e’ soggetto ad una maggiore pressione laterale. Ne’ risultano spesso tensioni e lesioni del menisco laterale.`
            },
            {
              name: `Artrite`,
              des: `Il ginocchio valgo grave puo’ eventualmente progredire verso l'artrite.`
            }
          ]
        },
        {
          name: 'Ginocchio recurvato',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [
            {
              name: `Degenerazione dell'articolazione del ginocchio`,
              des: `L'eccessiva usura e la degenerazione del ginocchio sono il risultato di un persistente ginocchio recurvato.`
            },
            {
              name: `Influenza sull'equilibrio del corpo`,
              des: `Le ginocchia deformate portano a cambiamenti di posizione di fianchi, bacino e caviglie e possono modificare gradualmente l'equilibrio di tutto il corpo.`
            }
          ]
        },
        {
          name: 'Gambe arcuate',
          key: 'legXO',
          normal: {
            normal: imgSrc.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [
            {
              name: 'Dolore alle ginocchia',
              des: `Quando il bacino si inclina in avanti, crea anche un disallineamento a 'griglia' sull'articolazione del ginocchio. Il femore non segue correttamente la tibia (stinco), creando uno squilibrio. Quando lo squilibrio e’ accoppiato a femori ruotati internamente (a causa della mancanza di forti glutei a causa dell'APT), si finisce con una ricetta perfetta per falsa curvatura delle ginocchia. \n` +
              `Si potrebbe sentire il ginocchio muoversi e cedere abbastanza spesso durante la giornata .`
            },
            {
              name: 'Artrite',
              des: 'Col passare del tempo, potresti iniziare a sentire dolore Poiche’ le strutture stabilizzanti (ad es. Cartilagine e legamenti) nel ginocchio si logorano a una velocit?molto piu’ rapida rispetto a un ginocchio neutro.'
            }
          ]
        }
      ]
    }
  },

  postureModalIpad: {
    detection: `Rilevato`,
    item: `elementi`,
    noHeightRisk: `Hai una sana postura, continua cosi’!`,
    otherDetecation: `altri elementi`,
    potentialRisk: `Rischio medio`,
    heightRisk: `Alto rischio`,
    suggest:
      `La tua postura deve migliorare, pochi minuti al giorno di esercizi posturali saranno molto utili `,
    suggestSolve:
      `Hai davvero bisogno di migliorare la tua postura, per favore contatta uno specialista per fare piu’ valutazioni`,
    normal: `Normale`,
    risk: `Rischio`,
    return: `ritorna`,
    levelName: `Alto | Medio |Basso`
  },

  postureModal: {
    normal: 'Normale',
    highRisk: 'Alto Rischio',
    goback: 'Indietro',
    potentialRisk: 'Rischio Medio',
    levelName: 'Alto | Medio | Basso',
    symptominterpretation: 'Suggerimenti',
    triggersymptoms: 'Impatto'
  },

  postureReport: {
    redAlert: `Zone rossa sta per tensione muscolare`,
    yellowAlert: `Zona gialla sta per debolezza muscolare`,
    muscleDire: {
      normal: `Normale`,
      face: `Davanti`,
      side: `Lato`,
      back: `Indietro`
    },
    details: {
      lh: `lh`,
      ll: `ll`,
      rh: `rh`,
      rr: `rr`
    },
    descripName: {
      upName: `deve essere rafforzato`,
      lowName: `deve essere  allungato`
    },
    navList: `Davanti | Lato | Dietro`,
    boneDescription: {
      face: {
        trunk: `Muscoli Addominali`,
        legForX: [`Muscoli abduttori dei fianchi`, `Muscoli adduttori dei fianchi`],
        legForO: `Muscoli abduttori dei fianchi`,
        legForStretch: `Quadricipite femorale`,
        round: `Pettorale`
      },
      side: {
        round: `Muscolo sternocleidomastoideo`,
        fore: `Muscolo sternocleidomastoideo`,
        shoulder: `Muscolo scaleno`
      },
      back: {
        spine: `Trapezio superiore`,
        shoulder: `Trapezio superiore`,
        round: [`Trapezio superiore`, `Trapezio inferiore`],
        fore: [`Trapezio superiore`, `Trapezio inferiore`],
        rake: `Muscolo elevatore della scapola`,
        legStretch: [`Muscoli del tendine del ginocchio`, `Fascia plantare`],
        legX: ['Muscoli abduttori dei fianchi', 'Bicipite femorale'],
        legO: ['Muscoli posteriori della coscia', 'Inventori'],
        legXO: ['Bicipite Femorale', 'Fascia Plantare']
      }
    }
  },

  postureSymp: {
    detection: 'Rilevato',
    item: 'elementi',
    noHeightRisk: 'Hai una postura sana, continua cosi!',
    otherDetecation: 'altri elementi',
    potentialRisk: 'Medio rischio',
    heightRisk: 'Alto Rischio',
    suggest: 'La tua postura deve migliorare, pochi minuti al giorno di esercizi posturali saranno molto utili ',
    suggestSolve: 'Hai davvero bisogno di migliorare la tua postura, per favore contatta uno specialista per fare piu’ valutazioni',
    normal: 'Normale',
    risk: 'Rischio'
  },

  postureSympIpad: {
    detection: 'Rilevato',
    item: 'elementi',
    noHeightRisk: 'Hai una postura sana, continua cosi!',
    otherDetecation: 'altri elementi',
    potentialRisk: 'Medio rischio',
    heightRisk: 'Alto Rischio',
    suggest: 'La tua postura deve migliorare, pochi minuti al giorno di esercizi posturali saranno molto utili ',
    suggestSolve: 'Hai davvero bisogno di migliorare la tua postura, per favore contatta uno specialista per fare piu’ valutazioni',
    normal: 'Normale',
    risk: 'Rischio'
  },

  posture: {
    bullet: {
      Home: `Home`,
      Posturedata: `Dati della Postura`,
      Score: `Valutazione del Rischio`,
      Muscle: `Valutazione muscolare`,
      Solution: `Soluzione`
    },
    viwesNav: `Lato | Davanti`,
    InvalidData: `Report non valido`,
    qrcode: `Mandaci una mail e sblocca i tuoi esercizi`,
    expertsWalk: `Senno Posture`,
    smallProgram: `support@sennotech.com`,
    clickRightTop: `Clicca il pulsante in alto a destra`,
    clickTranspond: `clicca per condividere il mini programma`,
    symptoms: {
      head: [
        {
          name: `Inclinazione`,
          key: `headSidesway`,
          normal: {
            left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [
            {
              name: `Sforzo cronico dei muscoli e dei legamenti`,
              des: `L'Inclinazione cefalica prolungata o il torcicollo possono portare a uno sforzo cronico del legamento cervicale posteriore e dei muscoli circostanti. `
            },
            {
              name: `Spondilosi cervicale`,
              des: `Il collo e’ una catena di 7 ossa collegate da legamenti e avvolte da muscoli che sostengono un peso di 7 kg ( la tua testa!) Il dolore al collo e’ un problema spesso attribuito al lavoro costante contro la gravita’ per bilanciare la testa sul busto.La posizione anormale dei tessuti molli e delle ossa da una testa ectopica aumenta il rischio di degenerazione dolorosa dei dischi intervertebrali`
            }
          ]
        },
        {
          name: `Testa in Avanti`,
          key: `headLean`,
          normal: {
            normal: imgSrc.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [
            {
              name: `Vertigini e Mal di testa`,
              des: `L'ipossia cerebrale causata da una cattiva circolazione derivante dalla postura con la testa in avanti puo’ portare a vertigini e mal di testa.`
            },
            {
              name: `Spondilosi cervicale`,
              des: `Il collo e’ una catena di 7 ossa collegate da legamenti e avvolte da muscoli che sostengono un peso di 7 kg ( la tua testa!) Il dolore al collo e’ un problema spesso attribuito al lavoro costante contro la gravita’ per bilanciare la testa sul busto.La posizione anormale dei tessuti molli e delle ossa da una testa ectopica aumenta il rischio di degenerazione dolorosa dei dischi intervertebrali`
            }
          ]
        }
      ],
      shoulder: [
        {
          name: `Spalle Irregolari`,
          key: `highLowShoulder`,
          normal: {
            left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [
            {
              name: `Mal di Testa Cronico`,
              des: `Spalle irregolari potrebbero causare mal di testa cronico.`
            },
            {
              name: `Speroni Ossei`,
              des: ` Le spalle non in linea generano una forza anormale sul collo, rendendo una persona incline alla degenerazione della colonna cervicale e in alcuni casi a speroni ossei`
            },
            {
              name: `Lombalgia`,
              des: `le spalle inclinate possono causare Inclinazione laterale del bacino, squilibrio muscolare in vita e lombalgia..`
            },
            {
              name: `Discrepanza Lunghezza Gambe`,
              des: `l'Inclinazione laterale pelvica aumenta anche il rischio di un'apparente disuguaglianza nella lunghezza delle gambe.`
            }
          ]
        },
        {
          name: `Spalle Curve`,
          key: `roundShoulder`,
          normal: {
            normal: imgSrc.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.ROUND_SHOULDER
          },
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [
            {
              name: `Malattie Cardiovascolari`,
              des: ` Le spalle curve aumentano la tensione del diaframma, aumentando il rischio di malattie cardiovascolari.`
            },
            {
              name: `MaldiTesta`,
              des: `La tensione del collo e delle spalle dovute a  spalle curve puo’ persino causare compressione del nervo cervicale e mal di testa.`
            },
            {
              name: `Arti Intorpiditi`,
              des: `La compressione del nervo cervicale puo’ anche provocare intorpidimento o parestesia delle braccia.`
            }
          ]
        }
      ],
      trunk: [
        {
          name: `Scoliosi`,
          key: `spineSidesway`,
          normal: {
            left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [
            {
              name: `Scoliosi`,
              des: `Ulteriore ispezione 3D e’ indicata per diagnosticare la scoliosi.`
            },
            {
              name: `Spalle Inclinate`,
              des: `La scoliosi puo’ essere accompagnata da spalle inclinate.`
            },
            {
              name: `Bacino Inclinato`,
              des: `La scoliosi puo’ essere accompagnato da bacino inclinato.`
            }
          ]
        }
      ],
      pelvis: [
        {
          name: `Bacino Inclinato`,
          key: `pelvisLean`,
          normal: {
            left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [
            {
              name: `Dolore Cronico`,
              des: `Un bacino inclinato puo’ causare dolore alle estremita'`
            },
            {
              name: `Ernia Disco Lombare`,
              des: `Un bacino inclinato puo’ aumentare il rischio di una ernia del disco lombare.`
            },
            {
              name: `Discrepanza Lunghezza Gambe`,
              des: `Un bacino inclinato puo’ aumentare il rischio di una discrepanza nella lunghezza delle gambe.`
            }
          ]
        }
      ],
      'lower extremity': [
        {
          name: `Gambe ad Arco (Curvatura ad O)`,
          key: `legO`,
          normal: {
            normal: imgSrc.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_O
          },
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [
            {
              name: `Lesione meniscale`,
              des: `La forza sull’ arto inferiore nelle persone con le gambe arcuate viene modificata a causa di cio’`
            },
            {
              name: `Artrite`,
              des: `Accentuate gambe ad arco possono causare artrite nello spazio interstiziale laterale dell’ articolazione.`
            }
          ]
        },
        {
          name: `Ginocchio valgo (Gambe ad X)`,
          key: `legX`,
          normal: {
            normal: imgSrc.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [
            {
              name: `Lesione Meniscale`,
              des: `Poiche’ le ginocchia ad X alterano la direzione della pressione dell’ arto inferiore, il ginocchio e’ soggetto ad una maggiore pressione laterale. Ne’ risultano spesso dolore e lesioni del menisco laterale .`
            },
            {
              name: `Artrite`,
              des: `Un grave ginocchio valgo puo’ eventualmente progredire in osteoartrite.`
            }
          ]
        },
        {
          name: `Ginocchio recurvato`,
          key: `kneeOverstretch`,
          normal: {
            normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [
            {
              name: `Degenerazione Articolazione Ginocchio`,
              des: `L’ eccessiva usura e la degenerazione del ginocchio sono il risulatato di un persistente ginocchio recurvato .`
            },
            {
              name: `Influenza Equilibrio Corpo`,
              des: `Le ginocchia deformate portano a cambiamenti di posizione di fianchi, bacino e caviglie e possono modificare gradualmente l'equilibrio di tutto il corpo .`
            }
          ]
        },
        {
          name: `Gambe arcuate`,
          key: `legXO`,
          normal: {
            normal: imgSrc.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [
            {
              name: `Dolore al ginocchio`,
              des: `Quando il bacino e’ inclinato in avanti, esso crea un disallineamento a griglia dell’ articolazione del ginocchio. Il femore non segue correttamente la tibia (stinco), creando uno squilibrio. Quando lo squilibrio e’ associato a intrarotazione del femore (a causa di debolezza muscolare dei glutei di APT, Inclinazione pelvica anteriore), cio’ porta a false ginocchia curve .\n` +
                `Si potrebbe sentire il ginocchio muoversi e cedere abbastanza spesso durante la giornata . `
            },
            {
              name: `Artrite`,
              des: `Con il passare del tempo potresti iniziare a sentire dolore dalle giunture (i.e. Cartilagine e legamenti) In questo tipo di ginocchio si consumano molto piu’ rapidamente rispetto ad un ginocchio neutro .`
            }
          ]
        }
      ]
    }
  },

  sympItem: {
    levelName: `alto | medio | basso`
  },

  sympItemIpad: {
    detection: `Rilevato`,
    item: `elementi`,
    noHeightRisk: `Hai una postura molto sana, Continua cosi’`,
    otherDetecation: `altri elementi`,
    potentialRisk: `Medio rischio`,
    heightRisk: `Alto rischio`,
    suggest:
      `La tua postura necessita di miglioramenti, pochi minuti al giorno di esercizi sulla postura saranno molto utili`,
    suggestSolve:
      `Hai davvero necessita’ di migliorare la tua postura, per favore contatta uno specialista per ulteri`,
    normal: `Normale`,
    risk: `Rischio`,
    levelName: `Alto | Medio | Basso`
  }
}
export { it }



// WEBPACK FOOTER //
// ./src/assets/lang.conf/it.js